import styled from "styled-components";

export const GlobalSearchContainer = styled.div`
  display: flex;
  gap: 8px;
  grid-area: srch;
`

export const FilterButton = styled.button<{ outline?: boolean }>`
  //font-family: 'FuturaPT', sans-serif;
  -webkit-tap-highlight-color: white;
  box-sizing: border-box;
  overflow: visible;
  text-transform: uppercase;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  border: 3px solid ${({ outline }) => outline ? "#0a2240" : "transparent"};
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: ${({ outline }) => outline ? "#fff" : "#0a2240"};
  padding: 5px 0px;
  width: 150px;
  color: ${({ outline }) => outline ? "#0a2240" : "#fff"};
  cursor: pointer;
  width: 200px;

  @media (max-width: 578px) {
    width: 150px;
    font-size: 16px;
  }
  //display: inline-block;
  //width: 200px;
  //padding: 5px 0px;
  //line-height: 1.5;
  //font-family: 'FuturaPT', sans-serif;
  //overflow: visible;
  //font-weight: 400;
  //text-align: center;
  //vertical-align: middle;
  //border: none;
  //border-radius: 8px;
  //background-color: rgb(239, 113, 58);
  //color: #fff;
  //text-transform: uppercase;
  //transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  //-webkit-tap-highlight-color: white;
  //cursor: pointer;
  //
  //@media (max-width: 578px) {
  //  width: 150px;
  //  font-size: 16px;
  //}
`
